import { render, staticRenderFns } from "./IndexShow.vue?vue&type=template&id=5f626692&scoped=true"
import script from "./IndexShow.vue?vue&type=script&lang=js"
export * from "./IndexShow.vue?vue&type=script&lang=js"
import style0 from "./IndexShow.vue?vue&type=style&index=0&id=5f626692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f626692",
  null
  
)

export default component.exports